import { FormControl, FormGroup, Validators } from "@angular/forms";
import { FormAnswer, FormAnswerObject } from "./form-answer.model";
import { FormTemplateQuestion } from "./form-template-question.model";

export class QuestionDate extends FormTemplateQuestion {
  public collectFormControl(answersToDefaultTo: FormAnswerObject): Record<string, FormControl> {
    let defaultValue: any = this.defaultValue;
    if (answersToDefaultTo[this.id] !== undefined) {
      const answer = answersToDefaultTo[this.id] as any;
      const editedAnswer = answer[this.getAnswerDataField(true)[0]];
      const originalAnswer = answer[this.getAnswerDataField(false)[0]];
      const updatedAt = String(answer["updatedAt"]);
      const utcDate = answer["createdAt"];
      const localDate = new Date(utcDate);
      if (localDate.toString() == updatedAt) {
        defaultValue =
          originalAnswer != null && originalAnswer.toString() != "" ? originalAnswer : editedAnswer;
      } else {
        defaultValue = editedAnswer;
      }
    }

    const defaultDate = this.parseDateValue(defaultValue);
    return {
      [this.getName()]: new FormControl(
        defaultDate ?? null,
        this.required ? Validators.required : Validators.nullValidator
      ),
    };
  }

  public collectAnswer(formGroup: FormGroup, isEdit: boolean): FormAnswer[] | null {
    const rawValue = formGroup.value[this.getName()];
    if (rawValue === null || rawValue === "") {
      return null;
    }

    const dateValue = this.parseDateValue(rawValue);
    if (!dateValue) {
      return null;
    }

    const formAnswer = new FormAnswer();
    formAnswer.formTemplateQuestionId = this.id;
    (formAnswer as any)[this.getAnswerDataField(isEdit)[0]] = dateValue;
    return [formAnswer];
  }

  private formatDateValue(value: any): string {
    if (value === null || value === undefined || value === "") {
      return "";
    }

    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) {
      return String(value);
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  private parseDateValue(value: any): Date | null {
    if (value === null || value === undefined || value === "") {
      return null;
    }

    if (value instanceof Date) {
      return value;
    }

    if (typeof value === "string") {
      const isoMatch = /^\d{4}-\d{2}-\d{2}$/;
      if (isoMatch.test(value)) {
        const date = new Date(value);
        return isNaN(date.getTime()) ? null : date;
      }

      const dmyMatch = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      const match = value.match(dmyMatch);
      if (match) {
        const [, day, month, year] = match;
        const date = new Date(Number(year), Number(month) - 1, Number(day));
        return isNaN(date.getTime()) ? null : date;
      }

      const parsed = new Date(value);
      return isNaN(parsed.getTime()) ? null : parsed;
    }

    return null;
  }

  public readDataFromAnswers(answers: Record<number, FormAnswer>, isEdit = false): string {
    if (answers[this.id]) {
      const answer = answers[this.id] as any;
      return this.formatDateValue(answer[this.getAnswerDataField(isEdit)[0]]);
    }
    return "";
  }
}
